import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';

import { Box, Typography, DialogContent, DialogTitle, Grid, TextField } from '@mui/material';

import { DialogFooter, DialogActionButton } from 'components/Dialog';

import { useStyles } from './styles';
import { compose } from 'utils/compose';
import { EDIT_NOTICE } from '../../constants/verbiage';
import withMediaQuery from '../../constants/mediaQuery';

// HOC to inject styles into class component
// no-dd-sa:javascript-code-style/parameter-name
const withUseStyles = (WrappedComponent) => {
  return function WithStylesWrapper(props) {
    const classes = useStyles();
    return <WrappedComponent {...props} classes={classes} />;
  };
};

class EditAddressDialog extends Component {
  constructor(props) {
    super(props);
    this.state = {
      street2: '',
    };
  }

  componentDidMount() {
    const { delivery, editedDeliveryData } = this.props.store.deliveryStore;
    const { shipment } = delivery;

    this.setState({ street2: editedDeliveryData.street2 || shipment.dropoff_address.street2 });
  }

  handleInputChange = (value) => {
    this.setState({ street2: value });
  };

  save = () => {
    const { deliveryStore } = this.props.store;
    const { street2 } = this.state;

    deliveryStore.setEditedDeliveryField('street2', street2);
    deliveryStore.saveAndCloseDialog();
  };

  render() {
    const { classes, store, mediaQuery } = this.props;
    const { deliveryStore } = store;
    const { delivery, tokenRemainingTimeString, editedDeliveryData } = deliveryStore;

    if (!delivery) return null;

    const { shipment } = delivery;
    const { dropoff_address } = shipment;

    return (
      <Box sx={classes.container}>
        <DialogTitle sx={classes.titleBox}>
          <Grid
            container
            justifyContent="space-between"
            alignItems={mediaQuery.isMobile ? 'flex-start' : 'center'}
            direction={mediaQuery.isMobile ? 'column' : 'row'}
            spacing={mediaQuery.isMobile ? 1 : 0}
          >
            <Grid sx={classes.dialogTitle}>
              <span style={{ fontWeight: 600 }}>Edit Address</span>
            </Grid>
            <Grid sx={classes.dialogTimer}>
              <Box component="span" sx={classes.underlined}>
                Session time:
              </Box>
              <Box component="span" sx={classes.timerCounter}>
                {tokenRemainingTimeString}
              </Box>
            </Grid>
          </Grid>
          <Box pt={2} pb={mediaQuery.isMobile ? 2 : 3} sx={classes.noticeBox}>
            <span style={{ fontWeight: 600 }}>{EDIT_NOTICE}</span>
          </Box>
        </DialogTitle>
        <DialogContent>
          <Box pb={3}>
            <Box pt={1} pb={3}>
              <Typography sx={{ ...classes.darkGrayText, ...classes.infoBox }}>
                We can only assist you to change Address Line 2 online. To change the full address, please contact our Dispatch Team at{' '}
                <strong style={{ color: '#666' }}>(855)-249-SHIP</strong>
              </Typography>
            </Box>
            <Grid container alignItems="center" spacing={mediaQuery.isMobile ? 2 : 4} sx={classes.addressEdit}>
              <Grid size={{ xs: 12, sm: 2 }} sx={classes.darkGrayText}>
                Address 1
              </Grid>
              <Grid size={{ xs: 12, sm: 10 }}>{dropoff_address.street}</Grid>

              <Grid size={{ xs: 12, sm: 2 }} sx={classes.darkGrayText}>
                Address 2
              </Grid>
              <Grid size={{ xs: 12, sm: 10 }} sx={classes.addressInputWrapper}>
                <TextField
                  variant="outlined"
                  margin="dense"
                  size="medium"
                  sx={classes.addressInput}
                  defaultValue={editedDeliveryData.street2 || dropoff_address.street2}
                  onChange={(e) => this.handleInputChange(e.target.value)}
                />
              </Grid>

              <Grid size={{ xs: 12, sm: 2 }} sx={classes.darkGrayText}>
                City
              </Grid>
              <Grid size={{ xs: 12, sm: 10 }}>{dropoff_address.city}</Grid>

              <Grid size={{ xs: 12, sm: 2 }} sx={classes.darkGrayText}>
                State
              </Grid>
              <Grid size={{ xs: 12, sm: 10 }}>{dropoff_address.state}</Grid>

              <Grid size={{ xs: 12, sm: 2 }} sx={classes.darkGrayText}>
                Zipcode
              </Grid>
              <Grid size={{ xs: 12, sm: 10 }}>{dropoff_address.zipcode}</Grid>
            </Grid>
          </Box>
        </DialogContent>
        <DialogFooter>
          <DialogActionButton onClick={() => deliveryStore.closeEditDialog()} color="primary" disableElevation>
            Cancel
          </DialogActionButton>
          <DialogActionButton onClick={this.save} variant="contained" color="primary" disableElevation>
            Save
          </DialogActionButton>
        </DialogFooter>
      </Box>
    );
  }
}

const EditAddressDialogCompose = compose(inject('store'), observer)(EditAddressDialog);

export default withUseStyles(withMediaQuery()(EditAddressDialogCompose));
